/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserFollowV2 = {
    properties: {
        teams: {
            type: 'array',
            contains: {
                type: 'UserFollowTeamV2',
            },
            isRequired: true,
        },
        players: {
            type: 'array',
            contains: {
                type: 'UserFollowPlayerV2',
            },
            isRequired: true,
        },
        matches: {
            type: 'array',
            contains: {
                type: 'UserFollowMatchV2',
            },
            isRequired: true,
        },
        leagues: {
            type: 'array',
            contains: {
                type: 'UserFollowLeagueV2',
            },
            isRequired: true,
        },
    },
} as const;
